import {capitalize} from "lodash";

const DEFAULT_LANGUAGE_SUFFIXES = ['En', 'Fr'];

function getFirstAvailablePropertyValue(source, propertyNames) {
	return propertyNames
		.map(propertyName => source?.[propertyName])
		.find(Boolean);
}

/**
 * Extracts a localized property value from an object based on the specified language.
 *
 * @param {Object} source - The object containing the localized properties.
 * @param {string} propertyName - The base property name to extract.
 * @param {string} lang - The language code to look for in the property name.
 * @param {boolean} [langStrict=false] - Whether to strictly find the property for the given language. If false, falls back to default language properties.
 * @return {string} The extracted property value for the specified language, or a fallback value if not found.
 */
export function extractLocaleProp(source, propertyName, lang, langStrict = false) {
	const localizedPropertyName = `${propertyName}${capitalize(lang)}`;
	const localizedValue = source?.[localizedPropertyName];
	const baseValue = source?.[propertyName];
	const strictValue = localizedValue || baseValue;

	if (langStrict) {
		return strictValue || '';
	}

	const fallbackPropertyNames = DEFAULT_LANGUAGE_SUFFIXES.map(
		languageSuffix => `${propertyName}${languageSuffix}`
	);
	const fallbackValue = getFirstAvailablePropertyValue(source, fallbackPropertyNames);

	return strictValue || fallbackValue || '';
}
